import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import ProjectDetailLayout from "layouts/projects/ProjectDetailLayout"

import { getProjectDetails } from "api/api";

// Importing Templates
import Huit from "components/projects/templates/Huit"
import FiftyFifty from "components/projects/templates/FiftyFifty";

const ProjectDetail = () => {
    const { projectCode } = useParams();
    const [project, setProject] = useState({});
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(true);  // Should start as true

    useEffect(() => {
        const fetchProjectDetails = async () => {
            try {
                const data = await getProjectDetails(projectCode);

                // Log to debug the structure
                //console.log("Fetched project data:", data);

                // Set project safely
                if (data && (data.project || data.template)) {
                    setProject(data.project || data);
                } else {
                    setErrors('Invalid project data received');
                }
            } catch (error) {
                console.error(error);
                setErrors('Failed to fetch project details');
            } finally {
                setLoading(false);
            }
        };
        fetchProjectDetails();
    }, [projectCode]);

    const renderTemplate = () => {
        switch (project.template) {
            case 'fiftyfifty':
                return <FiftyFifty project={project} />;
            case 'huit':
                return <Huit project={project} />;
            default:
                return <p>Error loading project template.</p>;
        }
    };

    return (
        <ProjectDetailLayout>
            {loading && <p>Loading...</p>}
            {errors && <p style={{ color: 'red' }}>{errors}</p>}

            {!loading && !errors && project.template && renderTemplate()}

            {!loading && !errors && !project.template && (
                <p style={{ color: 'orange' }}>No template specified for this project.</p>
            )}

        </ProjectDetailLayout>
    )
}

export default ProjectDetail;